import {request} from "@/network/request";




export function submit(ruleForm){
    return request({
        url:'/api/addrecord/',
        params:ruleForm
    })}
